import { getConfig } from '../config/appConfig';

export const SALES_EMAIL = getConfig('app.supportEmail') || 'sales@candorsys.com';

/**
 * Open the user's mail client to sales@candorsys.com (works better than window.open).
 */
export function sendSalesEmail({ subject, body } = {}) {
  const params = new URLSearchParams();
  if (subject) {
    params.set('subject', subject);
  }
  if (body) {
    params.set('body', body);
  }
  const query = params.toString();
  const href = query ? `mailto:${SALES_EMAIL}?${query}` : `mailto:${SALES_EMAIL}`;

  const link = document.createElement('a');
  link.href = href;
  link.rel = 'noopener noreferrer';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function buildCustomPlanMailtoBody(userEmail) {
  return [
    'Hello Candor Sales,',
    '',
    'I am interested in a custom / enterprise plan. Please contact me to discuss pricing, volume, and onboarding.',
    '',
    `Account email: ${userEmail || '(not provided)'}`,
    '',
  ].join('\n');
}

export function buildContactFormMailtoBody(form) {
  return [
    'Hello Candor Sales,',
    '',
    `Name: ${[form.firstName, form.lastName].filter(Boolean).join(' ') || '(not provided)'}`,
    `Title: ${form.title || '(not provided)'}`,
    `Company: ${form.companyName || '(not provided)'}`,
    `Email: ${form.email || '(not provided)'}`,
    `Phone: ${form.phone || '(not provided)'}`,
    '',
    form.message || '',
  ].join('\n');
}
